import { useAuth } from "@clerk/nextjs";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteUploadedPaper } from "helpers/api";

export const useDeleteUploadedPaper = () => {
  const queryClient = useQueryClient();
  const { getToken } = useAuth();

  const mutation = useMutation({
    mutationFn: async (paperId: string) => {
      const token = await getToken();
      const response = await deleteUploadedPaper(paperId, {
        authToken: token || undefined,
      });
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["uploaded-papers"]);
    },
  });

  return {
    deletePaper: mutation.mutateAsync,
    isDeleting: mutation.isLoading,
    error: mutation.error,
  };
};

export default useDeleteUploadedPaper;
